// API client — handles JWT (Authorization header) and Emergent cookie session transparently.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "maaya_token";

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

const client = axios.create({
  baseURL: API_BASE,
  // Platform ingress sets Access-Control-Allow-Origin: * which blocks credentials mode.
  // We use Authorization: Bearer <token> for both JWT (email/password) and session_token (Google).
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const api = {
  // Auth
  signup: (data) => client.post("/auth/signup", data),
  login: (data) => client.post("/auth/login", data),
  googleSession: (session_id) => client.post("/auth/google-session", { session_id }),
  me: () => client.get("/auth/me"),
  logout: () => client.post("/auth/logout"),
  forgotPassword: (email) => client.post("/auth/forgot-password", { email }),
  resetPassword: (data) => client.post("/auth/reset-password", data),
  changePassword: (data) => client.put("/auth/change-password", data),
  updateProfile: (data) => client.put("/auth/me", data),
  deleteAccount: () => client.delete("/auth/me"),

  // Sessions
  listSessions: () => client.get("/sessions"),
  createSession: (data) => client.post("/sessions", data),
  updateSessionCompletion: (id, completed) =>
    client.patch(`/sessions/${id}?completed=${completed}`),
  isDoneToday: () => client.get("/sessions/today/done"),

  // Journal
  listJournal: () => client.get("/journal"),

  // Micro actions
  listMicroActionLogs: () => client.get("/micro-actions/logs"),
  logMicroAction: (data) => client.post("/micro-actions/logs", data),

  // Trackers
  getTrackerToday: () => client.get("/trackers/today"),
  saveTrackerToday: (data) => client.put("/trackers/today", data),
  insights: () => client.get("/insights"),

  // Notifications
  getNotifications: () => client.get("/notifications"),
  updateNotifications: (data) => client.put("/notifications", data),

  // Analytics + subscription
  myAnalytics: () => client.get("/analytics/me"),
  subscriptionStatus: () => client.get("/subscription/status"),
  // Razorpay subscription endpoints
  listPlans: () => client.get("/razorpay/plans"),
  createSubscription: (plan_type) => client.post("/razorpay/create-subscription", { plan_type }),
  cancelSubscription: () => client.post("/razorpay/cancel-subscription"),
  changePlan: (plan_type) => client.post("/razorpay/change-plan", { plan_type }),
  listInvoices: () => client.get("/billing/invoices"),
  subscriptionHistory: () => client.get("/subscription/history"),
};

export default api;
